<div class="products-search">
  <i class="pi pi-search"></i>
  <input
    type="search"
    name="search"
    id="search"
    placeholder="Find products"
    class="products-search-input"
  />
</div>
